import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Subscription } from "rxjs";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { ReportService } from "../../Report/report.service";
import { ReportFileTypeDialogComponent } from "../shared/report-file-type-dialog/report-file-type-dialog.component";
import { DataService_StudentRelease } from "./shared/data.service";
import { StudentAddReleaseComponent } from "./student-add-release/student-add-release.component";
import { StudentEditReleaseComponent } from "./student-edit-release/student-edit-release.component";
import * as moment from "moment";

@Component({
	selector: "app-student-release",
	templateUrl: "./student-release.component.html",
	styleUrls: ["./student-release.component.css"],
})
export class StudentReleaseComponent implements OnInit {
	constructor(
		private userService: UserService,
		private StudentReleaseService: DataService_StudentRelease,
		private selectService: PersonSelectorService,
		private dialogService: DialogService,
		private reportService: ReportService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadSchoolist();

		this.subscription = this.selectService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
			// this.loadSemester();
			// this.loadPeriod();
			// this.loadSchoolDay();
			this.loadReleaseSchedule();
		});
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	SchoolID: any = 0;
	lstSchool: any = [];

	SelectMode: any = "PersonMode"; //Person, School or All

	//Person Selector
	subscription: Subscription;
	SelectedPerson: any;

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	isProcessing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedReleaseSchedule: any;
	lstReleaseSchedule: any = [];

	//Filter lists
	lstStudentID: any = [];
	lstHomeroom: any = [];
	lstReleaseTypeDesc: any = [];
	lstExcuseDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "Name", header: "Name" },
		{ field: "StudentID", header: "Student ID" },
		{ field: "Homeroom", header: "Homeroom" },
		{ field: "ReleaseTypeDesc", header: "Type" },
		{ field: "StartDateDesc", header: "Start Date" },
		{ field: "EndDateDesc", header: "End Date" },
		{ field: "ReleaseTimeDesc", header: "Release Time" },
		{ field: "AdmitTimeDesc", header: "Admit Time" },
		{ field: "Comment", header: "Reason" },
		{ field: "ExcuseDesc", header: "Excuse" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.SchoolID = this.lstSchool[0].SchoolID;
			},
			(error) => {}
		);
	}

	loadReleaseSchedule() {
		this.loading = true;

		//Format dates
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.loading = false;
			return;
		}

		var result: any;
		if (this.SelectMode == "PersonMode") {
			result = this.StudentReleaseService.ReleaseScheduleSelectList(fsDate, feDate, this.SelectedPerson.PersonID, this.SelectedPerson.SchoolID);
		} else if (this.SelectMode == "SchoolMode") {
			result = this.StudentReleaseService.ReleaseScheduleSelectList(fsDate, feDate, -1, this.SchoolID);
		} else if (this.SelectMode == "AllMode") {
			result = this.StudentReleaseService.ReleaseScheduleSelectList(fsDate, feDate, -1, -1);
		}

		result.subscribe(
			(response) => {
				this.lstReleaseSchedule = response;

				for (var i = 0; i < this.lstReleaseSchedule.length; i++) {
					var next = this.lstReleaseSchedule[i];

					next.StartDateDesc = next.Startdate == "" ? "" : moment(new Date(next.Startdate)).format("MM/DD/YYYY");
					next.EndDateDesc = next.Enddate == "" ? "" : moment(new Date(next.Enddate)).format("MM/DD/YYYY");
					next.ReleaseTimeDesc = next.ReleaseTime == "" ? "" : moment(new Date(next.ReleaseTime)).format("h:mm a");
					next.AdmitTimeDesc = next.AdmitTime == "" ? "" : moment(new Date(next.AdmitTime)).format("h:mm a");
				}

				//Load Data Filter Lists
				this.lstStudentID = Array.from(new Set(this.lstReleaseSchedule.map((item: any) => item.StudentID))).sort();
				this.lstHomeroom = Array.from(new Set(this.lstReleaseSchedule.map((item: any) => item.Homeroom))).sort();
				this.lstReleaseTypeDesc = Array.from(new Set(this.lstReleaseSchedule.map((item: any) => item.ReleaseTypeDesc))).sort();
				this.lstExcuseDesc = Array.from(new Set(this.lstReleaseSchedule.map((item: any) => item.ExcuseDesc))).sort();

				this.loading = false;
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadReleaseSchedule();
	}

	//Custom Button Methods
	onAddRelease() {
		this.errorMessage = "";

		var ref = this.dialogService.open(StudentAddReleaseComponent, {
			header: "Add Release",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SelectedPerson: this.SelectedPerson,
				user: this.user,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadReleaseSchedule();
			}
		});
	}

	onEditRelease() {
		this.errorMessage = "";

		if (this.SelectedReleaseSchedule == undefined) {
			this.errorMessage = "Select a Release to edit";
			return;
		}

		var ref = this.dialogService.open(StudentEditReleaseComponent, {
			header: "Edit Release",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SelectedPerson: this.SelectedPerson,
				user: this.user,
				SelectedReleaseSchedule: this.SelectedReleaseSchedule,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadReleaseSchedule();
			}
		});
	}

	onDeleteRelease() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedReleaseSchedule == undefined) {
			this.errorMessage = "Select a Release to delete";
			return;
		}

		//Call SP
		var result = this.StudentReleaseService.ReleaseScheduleDelete(this.SelectedReleaseSchedule.ReleaseScheduleID);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadReleaseSchedule();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the Release",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onPrintReleasePass() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedReleaseSchedule == undefined) {
			this.errorMessage = "Select a Release to Print";
			return;
		}

		//Call SP

		var ref = this.dialogService.open(ReportFileTypeDialogComponent, {
			header: "Report File Type",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response > 0) {
				this.FinishPrint(response);
			}
		});
	}

	FinishPrint(OutputType) {
		//Call SP

		var component = this;
		this.isProcessing = true;

		this.errorMessage = "";

		var strParam = "";

		//
		//Params from filtering:
		//

		//Parameter 1: ReleaseScheduleID
		strParam += this.SelectedReleaseSchedule.ReleaseScheduleID + "|ReleaseScheduleID";

		//Parameter 2: ReleaseDT
		strParam += "," + moment(new Date()).format("MM/DD/YYYY") + "|ReleaseDT";

		var reportID: any = 283;

		//Add type selector
		var result = this.reportService.Print(reportID, strParam, this.SelectedPerson.SchoolID, OutputType);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onSelectModeChange(val) {
		this.SelectMode = val;

		this.loadReleaseSchedule();
	}

	onSchoolChange(val) {
		this.SchoolID = val;

		if (this.SelectMode == "SchoolMode") {
			this.loadReleaseSchedule();
		}
	}

	onStartDateChange(val) {
		this.StartDate = val;

		this.loadReleaseSchedule();
	}

	onEndDateChange(val) {
		this.EndDate = val;

		this.loadReleaseSchedule();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedReleaseSchedule = val.data;
	}
	onRowUnselect(val) {
		this.SelectedReleaseSchedule = null;
	}
	onRowDblClick(ReleaseSchedule) {
		this.SelectedReleaseSchedule = ReleaseSchedule;
		this.onEditRelease();
	}
	////////////////////////////////////////////
}
